import React from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';
import { CarouselItemContainer } from '../../../PrimeurCampaign/components/CarouselItem';

const CarouselItem = ({
  type,
  created_at,
  store_name,
  market_name,
  local_price,
  local_currency,
  evolution,
  wine_name,
  vintage
}) => {
  return (
    <CarouselItemContainer evolution={evolution}>
      <div className="surveyValue">
        <p className="value">
          {local_price.toLocaleString('fr-FR', {
            style: 'currency',
            currency: local_currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })}
          {(evolution || evolution === 0) && (
            <span className="evolution">
              {evolution > 0 && '+'}
              {parseInt(evolution * 100, 10)}%
            </span>
          )}
        </p>
      </div>
      <div>
        <div className="headerPrimeurCarouselItem">
          <h3 className="titlePrimeurCarouselItem">{type}</h3>
        </div>
        <div className="content">
          <div className="carouselRowContent">
            <div>
              <p className="info">
                <span className="name">{store_name}</span> - {market_name}
              </p>
              <p className="info">{`${wine_name} - ${vintage}`}</p>

              <p className="date">{moment(created_at).format('DD/MM/YYYY')}</p>
            </div>
          </div>
        </div>
      </div>
    </CarouselItemContainer>
  );
};

CarouselItem.propTypes = {
  type: PropTypes.string.isRequired,
  created_at: PropTypes.string.isRequired,
  store_name: PropTypes.string.isRequired,
  market_name: PropTypes.string.isRequired,
  local_price: PropTypes.number.isRequired,
  local_currency: PropTypes.string.isRequired,
  evolution: PropTypes.number.isRequired,
  wine_name: PropTypes.string.isRequired,
  vintage: PropTypes.string.isRequired
};

export default CarouselItem;
